/**
 * InstructionPanel — collapsible "how to" callout primitive.
 *
 * A title row with a chevron toggles a body slot open/closed. Used
 * for "How to get your Jama OAuth credentials", "Where to find
 * field keys in Jama", "JIRA prerequisites", etc. — anything that's
 * supplementary documentation inside a settings/configuration
 * surface.
 *
 * Usage:
 *   <InstructionPanel title="How to get your Jama OAuth credentials">
 *     <p>To connect, you need a Jama client application…</p>
 *     <ol>
 *       <li>Open <strong>User Profile</strong> in Jama.</li>
 *       …
 *     </ol>
 *   </InstructionPanel>
 *
 *   // Start expanded (e.g. for first-run instructions the user
 *   // shouldn't have to discover):
 *   <InstructionPanel title="Prerequisites" defaultOpen>
 *     <ol><li>…</li></ol>
 *   </InstructionPanel>
 */
import React, { useState } from 'react';
import styles from './InstructionPanel.module.css';

const ChevronIcon = ({ open }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}
    aria-hidden="true"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const InstructionPanel = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={styles.panel}>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <ChevronIcon open={open} />
        <span className={styles.title}>{title}</span>
      </button>
      {open && <div className={styles.body}>{children}</div>}
    </div>
  );
};

export default InstructionPanel;
